export const createLoopProduct = (element) => {
  const instance = {
    $element: null,
    $addToCartButton: null,
    $visitCartButton: null,
    defaultAddToCartText: null,
    productId: null,
    disableCartPopup: false,
    init: function (element) {
      this.$element = jQuery(element);
      this.$addToCartButton = this.$element.find(".js-add-to-cart-button");
      this.$visitCartButton = this.$element.find(
        ".js-product-visit-cart-button"
      );
      this.defaultAddToCartText = this.$addToCartButton.text();
      this.productId = this.$addToCartButton.data("product-id");
      this.disableCartPopup = this.$addToCartButton.data("disable-cart-popup");
    },
    addCartButtonClickHandler: function (callback) {
      this.$addToCartButton.on("click", (e) => {
        callback(e);
      });
    },
    loading: function () {
      this.$addToCartButton
        .prop("disabled", true)
        .text(hs.strings.addingToCart);
    },
    done: function () {
      this.$addToCartButton
        .prop("disabled", false)
        .text(this.defaultAddToCartText);
    },
    hideAddToCartButton: function () {
      this.$addToCartButton.hide();
    },
    showVisitCartButton: function () {
      this.$visitCartButton.show();
    },
  };
  instance.init(element);
  return instance;
};
